import { URL_MULTIPLE_FILTER_VALUE_SEPARATOR } from '../../constants';
import type {
  BooleanRefinedFacet,
  RangeRefinedFacet,
  RefinedFacet,
} from '../hooks/useRefinedFacets';
import type { Facets } from '../interfaces/facets';

export const extractRefinedFacetsFromFacets = (facets: Facets) =>
  Object.entries(facets || []).reduce<RefinedFacet[]>(
    (refinedFacets, [facetName, facet]) => {
      const isFacetRangeRefined =
        facet.type === 'range' &&
        (facet.rangeValue?.min !== undefined ||
          facet.rangeValue?.max !== undefined);
      if (isFacetRangeRefined) {
        return [
          ...refinedFacets,
          {
            type: 'range',
            value: facet.rangeValue,
            facetName,
          } as RangeRefinedFacet,
        ] as RefinedFacet[];
      }

      const activeFacetValues = facet.values.filter((value) => value.isRefined);
      if (!activeFacetValues.length) {
        return refinedFacets;
      }

      if (facet.type === 'bool') {
        return [
          ...refinedFacets,
          {
            type: 'boolean',
            facetName,
          } as BooleanRefinedFacet,
        ] as RefinedFacet[];
      }

      if (facet.type === 'checkbox' && facetName === 'rating_rounded_down') {
        return [
          ...refinedFacets,
          {
            facetName,
            value: activeFacetValues
              .map((activeFacetValue) => activeFacetValue.name)
              .sort()
              .join(URL_MULTIPLE_FILTER_VALUE_SEPARATOR),
            type: 'checkbox',
          },
        ];
      }

      return [
        ...refinedFacets,
        ...activeFacetValues.map((activeFacetValue) => ({
          facetName,
          value: activeFacetValue.name,
          type: facet.type,
        })),
      ] as RefinedFacet[];
    },
    [],
  );
